// extracted by mini-css-extract-plugin
export default {"addressSection":"tT-z","disabled":"uT-z","sectionButtons":"vT-z","logo":"wT-z"};